import { EncryptAES, DecryptAES } from "./crypto";
import store from "../store";



function SetUser(user) {
  if (user === null) {
    localStorage.removeItem("user");
  } else {
    localStorage.setItem(
      "user",
      EncryptAES(JSON.stringify(user), LoadCookie("gtoken"))
    );
    store.state.user = user;
  }
  return;
}

function LoadUser() {
  if (localStorage.getItem("user") !== null)
    try {
      return JSON.parse(
        DecryptAES(localStorage.getItem("user"), LoadCookie("gtoken"))
      );
    } catch (err) {
      return err;
    }
    return null;
}

function SetCookie(name, value) {
  $cookies.set(name, value, "30d");
  return;
}

function LoadCookie(name) {
  if ($cookies.isKey(name)) return $cookies.get(name);
}

function SaveStatePlugin(store) {
  store.subscribe((mutation, state) => {
    SetUser(state.user);
    // console.log("set user");
  });
}

export { SetUser, LoadUser, SetCookie, LoadCookie, SaveStatePlugin };
